/**
 * Предпросмотр экономики для интерфейса (§Т5.2).
 *
 * Назначение файла: перевод ответа сервера в формат панелей. Деньги на экране —
 * только из GET /wallet; здесь нет симуляций списаний.
 */

import {
  crystalsToMilli,
  debtLimitMilli,
  type DebtTier,
  type Milli,
} from "@hive/shared";

import type { ServerWalletView } from "../api/wallet.js";

/** Состояние кошелька для панели сверху. Значения в milli для formatCrystals. */
export interface WalletView {
  readonly hive: Milli;
  readonly cash: Milli;
  readonly debt: Milli;
  readonly held: Milli;
  readonly effective: Milli;
  readonly debtLimit: Milli;
  readonly tier: DebtTier;
  readonly tributeCapLeft: Milli;
}

/** Сервер отдаёт целые кристаллы; форматтеры @hive/i18n ждут milli. */
export function walletViewFromServer(
  server: ServerWalletView,
  level: number,
  tributeCapLeftCrystals = 0,
): WalletView {
  return {
    hive: crystalsToMilli(server.hive),
    cash: crystalsToMilli(server.cash),
    debt: crystalsToMilli(server.debt),
    held: crystalsToMilli(server.held),
    effective: crystalsToMilli(server.effective),
    debtLimit: debtLimitMilli(level),
    tier: server.debtTier,
    tributeCapLeft: crystalsToMilli(tributeCapLeftCrystals),
  };
}
